import React from "react";
// --- Import Swiper React components ---
import { Swiper, SwiperSlide } from "swiper/react";
// --- Import Swiper modules ---
import { Pagination } from "swiper/modules";

// --- Import Swiper styles ---
import "swiper/css";
import "swiper/css/pagination";

import ProductCard from "../../../../product/components/common/ProductCard";
import type { TransformedProduct } from "../../../../product/types/productApiTypes";

interface FeaturedProductsProps {
  products: TransformedProduct[];
  title: string;
  seeAllLink?: string;
  seeAllText?: string;
  paginationClassName: string; // --- ADD THIS PROP ---
}

const FeaturedProducts: React.FC<FeaturedProductsProps> = ({
  products,
  title,
  seeAllLink,
  seeAllText,
  paginationClassName, // --- RECEIVE THIS PROP ---
}) => {
  return (
    <section className="featured-products-section">
      <h2 className="section-title">{title}</h2>

      <div className="swiper-container-wrapper">
        <Swiper
          modules={[Pagination]}
          loop={false}
          spaceBetween={30}
          pagination={{
            // --- START MODIFICATION ---
            el: `.${paginationClassName}`, // Use the dynamic class selector
            // --- END MODIFICATION ---
            clickable: true,
          }}
          breakpoints={{
            576: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          }}
          className="featured-products-carousel"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductCard product={product} viewMode="grid" />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* --- START MODIFICATION --- */}
        {/* Render the pagination element with its unique class */}
        <div className={`swiper-pagination ${paginationClassName}`}></div>
        {/* --- END MODIFICATION --- */}
      </div>

      {seeAllLink && seeAllText && (
        <div className="section-footer">
          <a href={seeAllLink} className="button button-secondary">
            {seeAllText}
          </a>
        </div>
      )}
    </section>
  );
};

export default FeaturedProducts;
